import { render, staticRenderFns } from "./AccountsLog.vue?vue&type=template&id=52e08647&scoped=true&"
import script from "./AccountsLog.vue?vue&type=script&lang=js&"
export * from "./AccountsLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e08647",
  null
  
)

export default component.exports